import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiService } from '../services/api.service';

import { ActiveCampaign, isActiveCampaign } from './campaign-contract';

export type CampaignReadOutcome =
  | { kind: 'blank' }
  | { kind: 'active'; campaign: ActiveCampaign }
  | { kind: 'notFound' }
  | { kind: 'failed' };

@Injectable({ providedIn: 'root' })
export class CampaignReadService {
  private readonly api = inject(ApiService);

  // Same prefix as the utm_source channel read (`/umanager/channels` in UManagerSlugService).
  // ApiService adds `environment.apiUrl`. Server contract remains `GET /api/campaigns/code/{code}`.
  read(code: string | null | undefined): Observable<CampaignReadOutcome> {
    const trimmed = (code ?? '').trim();
    if (!trimmed) {
      return of({ kind: 'blank' });
    }

    return this.api
      .get<unknown>('/umanager/campaigns/code/' + encodeURIComponent(trimmed))
      .pipe(
        map(body =>
          isActiveCampaign(body)
            ? { kind: 'active' as const, campaign: body }
            : { kind: 'failed' as const }
        ),
        catchError((error: unknown) =>
          of(
            error instanceof HttpErrorResponse && error.status === 404
              ? { kind: 'notFound' as const }
              : { kind: 'failed' as const }
          )
        )
      );
  }
}
